const Button = ({ children, className, submitting, disabled, ...rest }) => (
  <button
    className={cx('btn', className, { btn_spinner: submitting })}
    disabled={disabled || submitting}
    {...rest}
  >
    <span className="btn__text">{children}</span>
  </button>
);

export default Button;
